module.exports = __webpack_public_path__ + "img/hp-h1.1e70f45f.svg";